/** About & contact page. CONTACT_EMAIL lives in PrivacyPolicy.tsx - replace the placeholder there. */
import { NavLink } from 'react-router-dom';
import { CONTACT_EMAIL } from './PrivacyPolicy';
import KofiButton from '../components/KofiButton';

const heading: React.CSSProperties = {
  fontFamily: "'Cinzel', Georgia, serif",
  fontSize: '13px',
  fontWeight: 700,
  letterSpacing: '0.08em',
  textTransform: 'uppercase',
  color: 'var(--f-text-2)',
  margin: '28px 0 8px',
};

const text: React.CSSProperties = {
  fontFamily: "'Source Serif 4', Georgia, serif",
  fontSize: '14px',
  lineHeight: 1.7,
  color: 'var(--f-text-3)',
  margin: '0 0 12px',
};

const link: React.CSSProperties = { color: 'var(--f-primary)' };

export default function About() {
  return (
    <div style={{ maxWidth: '760px', margin: '0 auto', padding: '32px 20px 64px' }}>
      <h1 style={{
        fontFamily: "'Cinzel', Georgia, serif",
        fontSize: '22px',
        fontWeight: 700,
        color: 'var(--f-text)',
        marginBottom: '12px',
      }}>
        About Battle Standard
      </h1>

      <p style={text}>
        Battle Standard is a free army builder and battle companion for Warhammer: The Old World.
        It combines a full list builder - with live validation of army composition percentages,
        unit limits, options, magic items and upgrades - a turn tracker for use at the table, and
        a rules reference. It works offline as a Progressive Web App, and your lists are stored
        entirely on your own device.
      </p>

      <p style={text}>
        The project is maintained as a labour of love by a single hobbyist. Unit data is checked
        line-by-line against the published army books, FAQs and errata; corrections land
        regularly. If you spot a stat, cost or rule that doesn't match your book, please get in
        touch - the FAQ documents change things often, and we track every printed change.
      </p>

      <h2 style={heading}>Support the project</h2>
      <p style={text}>
        Battle Standard is free and always will be. If it has saved you time at the table and you'd
        like to chip in towards hosting and the hours behind the data checking, you can leave a tip.
        There's no obligation, and every feature stays available to everyone regardless.
      </p>
      <p style={{ margin: '4px 0 12px' }}>
        <KofiButton />
      </p>

      <h2 style={heading}>Contact & feedback</h2>
      <p style={text}>
        Bug reports, data corrections and suggestions are all welcome:{' '}
        <a href={`mailto:${CONTACT_EMAIL}`} style={link}>{CONTACT_EMAIL}</a>.
      </p>

      <h2 style={heading}>Attribution</h2>
      <p style={text}>
        Rules index by the Warhammer Fantasy Online Rules Index Project ({' '}
        <a href="https://tow.whfb.app" target="_blank" rel="noopener noreferrer" style={link}>tow.whfb.app</a>
        ). Icons by{' '}
        <a href="https://game-icons.net" target="_blank" rel="noopener noreferrer" style={link}>game-icons.net</a>{' '}
        (CC BY 3.0).
      </p>

      <h2 style={heading}>Legal</h2>
      <p style={text}>
        Battle Standard is entirely unofficial and is not endorsed by or affiliated with Games
        Workshop Limited. Warhammer: The Old World and all associated names and marks are the
        property of Games Workshop Limited. See our{' '}
        <NavLink to="/privacy" style={link}>privacy policy</NavLink> for how data is handled.
      </p>
    </div>
  );
}
